import { render } from "./Educators.vue?vue&type=template&id=af4e53cc&scoped=true"
import script from "./Educators.vue?vue&type=script&lang=js"
export * from "./Educators.vue?vue&type=script&lang=js"

import "./Educators.vue?vue&type=style&index=0&id=af4e53cc&scoped=true&lang=css"

import exportComponent from "/Users/ward/Projects/Chelsea/sherryV2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af4e53cc"]])

export default __exports__